<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'account.cancel_subscription' | translate}}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            {{'cancel.description1' | translate}}{{functionsService.convertUTCDateToLocalDateOnly(_endDate)}}. {{'cancel.description2' | translate}}
        </div>
    </div>
    <hr>
    <div class="row mb-2">
        <div class="col-12">
            {{'cancel.before' | translate}}
        </div>
    </div>
    <fieldset>
        <legend class="h6"><strong>{{'cancel.reason' | translate}}<span class="error">*</span></strong></legend>
        <form class="w-100" [formGroup]="cancelSubscriptionForm" (ngSubmit)="cancelSubscription()" name="form">
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-radio">
                        <input ngbAutofocus tabindex="0" id="expensive" type="radio" class="custom-control-input" value="Expensive" name="cancelReason" formControlName="cancelReason" (click)="hideBox()">
                        <label class="custom-control-label" for="expensive">{{'cancel.expensive' | translate}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-radio">
                        <input tabindex="0" id="complicated" type="radio" class="custom-control-input" value="Complicated" name="cancelReason" formControlName="cancelReason" (click)="hideBox()">
                        <label class="custom-control-label" for="complicated">{{'cancel.complicated' | translate}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-radio">
                        <input tabindex="0" id="needs" type="radio" class="custom-control-input" value="Needs" name="cancelReason" formControlName="cancelReason" (click)="hideBox()">
                        <label class="custom-control-label" for="needs">{{'cancel.needs' | translate}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-radio">
                        <input tabindex="0" id="work" type="radio" class="custom-control-input" value="Work" name="cancelReason" formControlName="cancelReason" (click)="hideBox()">
                        <label class="custom-control-label" for="work">{{'cancel.work' | translate}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-radio">
                        <input tabindex="0" id="other" type="radio" class="custom-control-input" value="Other" name="cancelReason" formControlName="cancelReason" (click)="openBox()">
                        <label class="custom-control-label" for="other">{{'general.other' | translate}}</label>
                    </div>
                    <ng-container *ngIf="cancelSubscriptionForm.get('cancelReason').invalid && formSubmitted">
                        <div *ngIf="cancelSubscriptionForm.get('cancelReason').hasError('required')" class="error ta-left">
                            {{'general.required_field' | translate}}
                        </div>
                    </ng-container>
                </div>
            </div>
            <div id="otherBox" class="row mt-2 ml-0 mb-2 mr-0">
                <div class="col-12">
                    <label for="comment">{{'subscription.please_specify' | translate}}</label>
                </div>
                <div class="col-12">
                    <textarea type="text" formControlName="cancelComment" id="comment" class="md-textarea form-control" maxlength="250" [ngClass]="{ 'is-valid': cancelComment['valid'], 'is-invalid': cancelComment['invalid'] }"  ></textarea>
                    <ng-container *ngIf="cancelSubscriptionForm.get('cancelComment').invalid && (formSubmitted || cancelSubscriptionForm.get('cancelComment').touched || cancelSubscriptionForm.get('cancelComment').dirty)">
                        <div *ngIf="cancelSubscriptionForm.get('cancelComment').hasError('pattern')" class="error ta-left">
                            {{'error.org_name' | translate}}
                        </div>
                        <div *ngIf="cancelSubscriptionForm.get('cancelComment').hasError('required')" class="error ta-left">
                            {{'general.required_field' | translate}}
                        </div>
                    </ng-container>
                </div>
            </div>
            <hr class="hr-m">
            <div class="row">
                <div class="col-12 text-right">
                    <button id="cancelEdit" type="button" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
                        {{'general.cancel' | translate}}
                    </button>
                    <button type="submit" class="btn btn-green btn-h-green">
                        {{'cancel.unsubscribe' | translate}}
                    </button>
                </div>
            </div>
        </form>
    </fieldset>
</div>
